import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { AFFILIATE_LINKS } from "../lib/affiliates";
import { trackAffiliateClick } from "../lib/analytics";

export default function AffiliateBanner() {
    const [open, setOpen] = useState(true);
    const { t } = useI18n();
    if (!open) return null;

    return (
        <div data-testid="affiliate-top-banner" className="w-full bg-[#0F172A] text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-4">
                <div className="flex items-center gap-2.5 min-w-0">
                    <span className="hidden sm:inline-flex h-6 w-6 items-center justify-center rounded-md bg-[#10B981]/15 text-[#10B981]">
                        <Sparkles className="h-3.5 w-3.5" />
                    </span>
                    <p className="text-sm truncate">
                        <span className="font-semibold">{t("banner.needHelp")}</span>{" "}
                        <span className="text-slate-300">{t("banner.ctaText")}</span>
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <a
                        data-testid="affiliate-banner-cta"
                        href={AFFILIATE_LINKS.bannerCta}
                        target="_blank"
                        rel="noopener noreferrer sponsored"
                        onClick={() => trackAffiliateClick("quaderno", "banner")}
                        className="text-sm font-semibold text-[#10B981] hover:text-emerald-300 underline-offset-4 hover:underline whitespace-nowrap"
                    >
                        {t("banner.cta")}
                    </a>
                    <button
                        data-testid="dismiss-banner-btn"
                        onClick={() => setOpen(false)}
                        aria-label={t("banner.dismiss")}
                        className="ml-1 inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-white/10 transition-colors"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
